<div class="coverpath-base-widget payment-if-missing">
  <div class="header">
    <div class="header__content header__content-close">
      <button type="button" class="close" (click)="cancel()">Close</button>
    </div>
  </div>
  <div class="wrap wrapMain payment-if-missing--main">
    <div class="wrap wrapHead payment-if-missing--head">
      <div class="pageHead">
        <div
          *ngIf="
            instanceName === 'payment-tlic' || instanceName === 'information-tlic' || instanceName === 'confirm-tlic'
          "
          class="removeTopMargin"
        >
          <h1>Accept or Decline Temporary Coverage</h1>
          <h2>Temporary coverage provides immediate protection for up to 120 days while you await your final offer.</h2>
        </div>
        <h1
          class="removeTopMargin"
          *ngIf="
            instanceName === 'payment' ||
            instanceName === 'payment-express' ||
            instanceName === 'payment-then-client-esign'
          "
        >
          Payment Information
        </h1>
        <h1 class="removeTopMargin" *ngIf="instanceName === 'conversion-payment'">Enter Payment Information</h1>
      </div>
      <div
        *ngIf="
          instanceName === 'payment' ||
          instanceName === 'payment-express' ||
          instanceName === 'payment-then-client-esign' ||
          instanceName === 'conversion-payment'
        "
        class="subhead"
      >
        Provide the information for the bank account you’ll use to pay your premium.<br />
        After you sign your additional documents on the next page, we will draft your first premium<br />
        and activate your coverage.
      </div>
      <div class="center">
        <img src="/common/widgets/icons/divider.svg" />
      </div>
    </div>
    <div class="section-container">
      <div class="half-section payment-if-missing--information">
        <payment-if-missing-policy-info [instanceName]="instanceName"></payment-if-missing-policy-info>
      </div>
      <div class="half-section payment-if-missing--form">
        <div *ngIf="instanceName != 'confirm-tlic'" class="payment-if-missing--form-headline">Payment Method</div>
        <div *ngIf="instanceName == 'confirm-tlic'" class="payment-if-missing--form-headline">
          Do you want temporary coverage?
          <div class="quote-page-product__field-group confirm-tlic-controls">
            <div class="quote-page-product__field quote-page-product__field--face-amount">
              <button
                cp-button
                class="payment-if-missing payment-if-missing--button-proceed confirm-tlic-controls"
                (click)="proceedToPayment()"
              >
                Yes, Proceed to Payment
              </button>
              <button
                cp-button
                class="payment-if-missing payment-if-missing--button-decline confirm-tlic-controls"
                theme="blue-alt"
                variant="primary"
                size="regular"
                (click)="declineTlicOffer()"
              >
                No, Decline
              </button>
              <button
                class="button button--blue button--secondary button--no-border modal__button__button-close payment-if-missing payment-if-missing--button-back confirm-tlic-controls"
                (click)="cancel()"
              >
                Back
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="instanceName == 'information-tlic'">
          {{ existingAccountType }} account ending in {{ accountEnding }}
        </div>
        <div
          *ngIf="instanceName != 'information-tlic' && instanceName != 'confirm-tlic'"
          class="quote-page-product__fields payment-if-missing--fields"
        >
          <div class="quote-page-product__field-group">
            <div class="quote-page-product__field quote-page-product__field--face-amount">
              <select-basic
                propertyName="accountCenterController.paymentInformation.paymentAccountType"
                label="Account Type"
                (valueChanged)="updateValidation()"
                #accountType
              ></select-basic>
              <basic-text-input
                propertyName="accountCenterController.paymentInformation.paymentBankName"
                placeholder="Bank Name"
                label="Bank Account"
                (change)="updateValidation()"
                #bankName
              ></basic-text-input>
              <basic-text-input
                propertyName="accountCenterController.paymentInformation.paymentABA"
                placeholder="Routing Number"
                label="Routing Number"
                (change)="updateValidation()"
                #ABA
              >
              </basic-text-input>
              <basic-text-input
                propertyName="accountCenterController.paymentInformation.paymentAccount"
                placeholder="Account Number"
                label="Account Number"
                (change)="updateValidation()"
                #Account
              >
              </basic-text-input>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="instanceName != 'information-tlic' && instanceName != 'confirm-tlic' && isInvalidPaymentInfo()"
        class="payment-if-missing--alert-container"
      >
        <cpds-alert intent="danger" class="payment-if-missing--alert-container">
          <span>{{ paymentInfoError }} </span>
        </cpds-alert>
      </div>
    </div>
    <div
      *ngIf="
        paymentFrequency === 'annual' &&
        instanceName !== 'information-tlic' &&
        instanceName !== 'confirm-tlic' &&
        instanceName !== 'payment-tlic'
      "
    >
      <div>
        <basic-checkbox
          id="isAutoPay"
          displayText="Enroll in a Pre-Authorized Payment Plan"
          propertyName="accountCenterController.paymentInformation.isAutoPay"
        ></basic-checkbox>
        With a Pre-Authorized Payment Plan (PAPP), we’ll draft your premium payment automatically using the information
        provided above. You’ll receive a reminder 9 days before the automatic payment date. Monthly payment frequencies,
        scheduled ALIR payments and third party payers must be enrolled in a Pre-Authorized Payment Plan. If you are on
        an annual payment frequency and choose not to enroll, simply uncheck the box above and we will email you
        instructions on how to pay 30 days before the payment due date.
      </div>
    </div>
    <div class="payment-if-missing--button-outer-container">
      <div class="payment-if-missing--button-container">
        <button
          cp-button
          class="payment-if-missing payment-if-missing--button-proceed"
          *ngIf="instanceName === 'payment-tlic'"
          [disabled]="submitDisabled"
          (click)="applyUpdatedPaymentInformationAndAcceptTlicOffer()"
        >
          Continue to signature
        </button>
        <button
          cp-button
          class="payment-if-missing payment-if-missing--button-proceed"
          *ngIf="instanceName === 'payment-express'"
          [disabled]="submitDisabled"
          (click)="acceptAndSign()"
        >
          Continue to signature
        </button>
        <button
          cp-button
          class="payment-if-missing payment-if-missing--button-proceed"
          *ngIf="instanceName === 'information-tlic'"
          (click)="acceptTlicOffer()"
        >
          Continue to signature
        </button>
        <button
          cp-button
          class="payment-if-missing payment-if-missing--button-proceed"
          *ngIf="instanceName === 'payment'"
          [disabled]="submitDisabled"
          (click)="acceptOffer()"
        >
          Continue to signature
        </button>
        <button
          cp-button
          class="payment-if-missing payment-if-missing--button-proceed"
          *ngIf="instanceName === 'payment-then-client-esign'"
          [disabled]="submitDisabled"
          (click)="applyUpdatedPaymentInfoThenOpenClientEsignModal()"
        >
          Continue to signature
        </button>
        <button
          cp-button
          class="payment-if-missing payment-if-missing--button-proceed"
          *ngIf="instanceName === 'conversion-payment'"
          [disabled]="submitDisabled"
          (click)="applyConversionUpdatedPaymentInfoThenOpenClientEsignModal()"
        >
          Continue to signature
        </button>
        <br />
        <div *ngIf="instanceName === 'payment-then-client-esign' || 'payment-express'">
          <span>Your payment won’t be made until you sign your documents on the next page.</span>
        </div>
      </div>
    </div>
  </div>
</div>
